<div
  class="modal fade"
  [class.show]="visible"
  [style.display]="visible ? 'block' : 'none'"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  *ngIf="visible">

  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content border-0 shadow">
      <div class="modal-header">
        <div>
          <h5 class="modal-title mb-0">Deposit Details</h5>
          <div class="text-muted small" *ngIf="deposit">
            {{ deposit.depositId }}
          </div>
        </div>

        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
      </div>

      <div class="modal-body" *ngIf="deposit as item">
        <div class="row g-3">
          <div class="col-md-4">
            <div class="small text-muted">Amount</div>
            <div class="fw-semibold">
              {{ item.amount | smartAmount:item.currency.symbol }}
            </div>
          </div>

          <div class="col-md-4">
            <div class="small text-muted">Fee</div>
            <div class="fw-semibold">
              {{ item.feeAmount | smartAmount:item.currency.symbol }}
            </div>
          </div>

          <div class="col-md-4">
            <div class="small text-muted">Net Credited</div>
            <div class="fw-semibold">
              {{ item.netAmount | smartAmount:item.currency.symbol }}
            </div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Deposit ID</div>
            <div class="fw-semibold text-break">{{ item.depositId }}</div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Wallet ID</div>
            <div class="fw-semibold text-break">{{ item.walletId }}</div>
          </div>

          <div class="col-md-4">
            <div class="small text-muted">Currency</div>
            <div class="fw-semibold">{{ item.currency.code }}</div>
          </div>

          <div class="col-md-4">
            <div class="small text-muted">Status</div>
            <div>
              <span class="badge rounded-pill" [ngClass]="badgeClass(item.status)">
                {{ item.status }}
              </span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="small text-muted">Receipt Number</div>
            <div class="fw-semibold text-break">{{ item.receiptNumber || '-' }}</div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">External Reference</div>
            <div class="fw-semibold text-break">{{ item.externalReference }}</div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Gateway Reference</div>
            <div class="fw-semibold text-break">{{ item.gatewayReference || '-' }}</div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Payment Method</div>
            <div class="fw-semibold">{{ item.paymentMethod || '-' }}</div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Receipt Issued At</div>
            <div class="fw-semibold">
              {{ item.receiptIssuedAt ? (item.receiptIssuedAt | date:'medium') : '-' }}
            </div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Checkout Type</div>
            <div class="fw-semibold">{{ item.checkoutType || '-' }}</div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Gateway</div>
            <div class="fw-semibold">
              {{ item.gateway?.name || item.gateway?.code || '-' }}
            </div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Checkout URL</div>
            <div class="fw-semibold text-break">
              <a *ngIf="item.checkoutUrl" [href]="item.checkoutUrl" target="_blank" rel="noopener">
                Open checkout
              </a>
              <span *ngIf="!item.checkoutUrl">-</span>
            </div>
          </div>

          <div class="col-md-6" *ngIf="canShowReceiptActions">
            <div class="small text-muted mb-2">Receipt</div>
            <div class="d-flex gap-2 flex-wrap">
              <button class="btn btn-outline-primary btn-sm" type="button" (click)="viewReceipt()" [disabled]="loadingReceipt">
                View Receipt
              </button>
              <button class="btn btn-primary btn-sm" type="button" (click)="downloadReceipt()" [disabled]="loadingReceipt">
                Download PDF
              </button>
            </div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Created At</div>
            <div class="fw-semibold">{{ item.createdAt | date:'medium' }}</div>
          </div>

          <div class="col-md-6">
            <div class="small text-muted">Last Updated</div>
            <div class="fw-semibold">{{ item.lastUpdatedAt | date:'medium' }}</div>
          </div>

          <div class="col-12">
            <div class="small text-muted mb-1">Client Payload JSON</div>
            <pre class="bg-light border rounded p-3 small mb-0 text-wrap">{{ prettyJson(item.clientPayloadJson) }}</pre>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="close()">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop fade show" *ngIf="visible" (click)="close()"></div>